<template>
  <div class="tpehealth-app-template-carrier-screening-page col-block width-full">
    <div class="tpehealth-app-content-sub-container col-block width-full">
      <div class="tpehealth-app-content-sub-title-container row-block">
        <div class="tpehealth-app-content-sub-title">{{ '說明'/* ___ */ }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div class="tpehealth-app-content-sub-content-container col-block width-full">
        <div
          class="tpehealth-app-content-sub-content"
          v-html="[
            '以下為您逐項列舉最常見之遺傳疾病，讓您更了解帶因篩查的詳細項目。'
          ].join('<br>')/* ___ */"
        ></div>
      </div>
    </div>
    <div class="tpehealth-app-content-gene-table-containr col-block width-full">
      <div class="tpehealth-app-content-gene-table-main-containr col-block width-full">
        <layerTable
          :datas="geneTableDatas['帶因']"
          :option="geneTableOption"
        ></layerTable>
      </div>
    </div>
  </div>
</template>

<script>
import layerTable from '@/components/tpehealth/layout/layerTable.vue'
import attachmentGenes from '@/components/tpehealth/data/attachmentGenes.json'

export default {
  components: {
    layerTable
  },
  computed: {
    // static
    geneTableDatas () {
      return attachmentGenes
    },
    geneTableOption () {
      return {
        style: 'striped',
        options: [
          {
            title: '基因名稱'/* ___ */,
            width: '100px',
            value: data => data['基因名稱']
          },
          {
            title: '疾病名稱'/* ___ */,
            col: 'start',
            value: data => data['疾病名稱']
          },
          {
            title: '遺傳模式'/* ___ */,
            width: '150px',
            value: data => data['遺傳模式']
          }
        ]
      }
    }
  }
}
</script>
